<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Job Level</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="jobLevel.code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="jobLevel.desc"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" :class="classPadding">
            <v-text-field
              label="Grade"
              v-model="jobLevel.gradeDesc"
              :class="classPadding"
              clearable
              @click:clear="clearGrade"
              readonly
            >
              <template slot="append">
                <v-icon @click.stop="searchGrade">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" :class="classPadding">
            <v-text-field
              label="Step"
              v-model="jobLevel.stepDesc"
              :class="classPadding"
              clearable
              readonly
              @click:clear="clearStep"
            >
              <template slot="append">
                <v-icon @click.stop="searchStep">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
            <v-text-field
              label="Minimum Salary"
              type="number"
              :class="classPadding"
              v-model="jobLevel.minSalary"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
            <v-text-field
              label="Maximum Salary"
              type="number"
              :class="classPadding"
              v-model="jobLevel.maxSalary"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <!-- <list :key="componentKey">
        <template slot="actions" slot-scope="{item}">
          <v-btn @click.stop="edit(item)" text icon>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click.stop="deleteItem(item)" text icon>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>-->
      <pagination :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </pagination>
      <!-- <router-view /> -->

      <v-dialog v-model="editDialog" width="900" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Edit</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editJobLevel.code"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editJobLevel.desc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" :class="classPadding">
                <v-text-field
                  label="Grade"
                  v-model="editJobLevel.gradeDesc"
                  :class="classPadding"
                  clearable
                  @click:clear="clearGrade"
                  readonly
                >
                  <template slot="append">
                    <v-icon @click.stop="searchGrade">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" :class="classPadding">
                <v-text-field
                  label="Step"
                  v-model="editJobLevel.stepDesc"
                  :class="classPadding"
                  clearable
                  @click:clear="clearStep"
                  readonly
                >
                  <template slot="append">
                    <v-icon @click.stop="searchStep">mdi-magnify</v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
                <v-text-field
                  label="Minimum Salary"
                  type="number"
                  :class="classPadding"
                  v-model="editJobLevel.minSalary"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="3" :class="classPadding">
                <v-text-field
                  label="Maximum Salary"
                  type="number"
                  :class="classPadding"
                  v-model="editJobLevel.maxSalary"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="error" @click.stop="editDialog = false"
              >Close</v-btn
            >
            <v-btn
              text
              color="success"
              @click.stop="update"
              :loading="isUpdating"
              v-if="userAccess.update >= 1"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="gradeDialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Grade</span>
        </v-card-title>
        <v-card-text>
          <grade-list>
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectGrade(item)" text outlined
                >Select</v-btn
              >
            </template>
          </grade-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="gradeDialog = false" text
            >CLose</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="stepDialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Step</span>
        </v-card-title>
        <v-card-text>
          <step-list>
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectStep(item)" text outlined>Select</v-btn>
            </template>
          </step-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="stepDialog = false" text
            >CLose</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import List from "./List";
import Pagination from "./Pagination";
import GradeList from "../grade/List";
import StepList from "../step/List";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
import { isNullOrUndefined } from "../../../../../validation/validation";
const API_ENDPOINT = "/api/jobLevel";
export default {
  metaInfo: {
    title: "Job Level",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    // List,
    GradeList,
    StepList,
    Pagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    isUpdating: false,
    jobLevel: {},
    componentKey: 0,
    editJobLevel: {},
    editDialog: false,
    gradeDialog: false,
    stepDialog: false
  }),
  methods: {
    save() {
      this.isSaving = true;
      this.jobLevel.minSalary = isNullOrUndefined(this.jobLevel.minSalary) ? 0 : this.jobLevel.minSalary;
      this.jobLevel.maxSalary = isNullOrUndefined(this.jobLevel.maxSalary) ? 0 : this.jobLevel.maxSalary;
      this.$axios
        .post(`${API_ENDPOINT}`, this.jobLevel)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      var rel = Object.assign({}, item);
      this.editJobLevel = rel;
      this.editJobLevel.code = rel.jobCode;
      this.editJobLevel.desc = rel.jobDesc;
      this.editJobLevel.gradeCode = rel.grade;
      this.editJobLevel.stepCode = rel.step;
      this.editJobLevel.stepDesc = rel.stepDesc;
      this.editJobLevel.gradeDesc = rel.grdDesc;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.jobCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.jobLevel = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      this.editJobLevel.minSalary = isNullOrUndefined(this.editJobLevel.minSalary) ? 0 : this.editJobLevel.minSalary;
      this.editJobLevel.maxSalary = isNullOrUndefined(this.editJobLevel.maxSalary) ? 0 : this.editJobLevel.maxSalary;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editJobLevel)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    searchGrade() {
      this.gradeDialog = true;
    },
    searchStep() {
      this.stepDialog = true;
    },
    selectGrade(item) {
      if (!this.editDialog) {
        this.jobLevel.gradeCode = item.grdCode;
        this.jobLevel.gradeDesc = item.grdDesc;
      } else {
        this.editJobLevel.gradeCode = item.grdCode;
        this.editJobLevel.gradeDesc = item.grdDesc;
      }
      this.gradeDialog = false;
    },
    selectStep(item) {
      if (!this.editDialog) {
        this.jobLevel.stepCode = item.stepCode;
        this.jobLevel.stepDesc = item.stepDesc;
      } else {
        this.editJobLevel.stepCode = item.stepCode;
        this.editJobLevel.stepDesc = item.stepDesc;
      }
      this.stepDialog = false;
    },
    clearGrade() {
      if (!this.editDialog) {
        this.jobLevel.gradeCode = null;
        this.jobLevel.gradeDesc = null;
      } else {
        this.editJobLevel.gradeCode = null;
        this.editJobLevel.gradeDesc = null;
      }
    },
    clearStep() {
      if (!this.editDialog) {
        this.jobLevel.stepCode = null;
        this.jobLevel.stepDesc = null;
      } else {
        this.editJobLevel.stepCode = null;
        this.editJobLevel.stepDesc = null;
      }
    }
  },
  created() {
    this.getUserAccessRights("JobLevel");
  }
};
</script>